"use client";

import { ButtonHTMLAttributes } from "react";
import { FormatIcon, FormatType } from "./FormatIcon";

interface FormatButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  format: FormatType;
  active?: boolean;
  size?: "sm" | "md";
}

const sizeStyles: Record<"sm" | "md", { button: string; icon: number }> = {
  sm: { button: "w-7 h-8", icon: 14 },
  md: { button: "w-8 h-9", icon: 16 },
};

export function FormatButton({
  format,
  active = false,
  size = "md",
  className = "",
  ...props
}: FormatButtonProps) {
  const sizeStyle = sizeStyles[size];

  return (
    <button
      type="button"
      className={`
        flex items-center justify-center transition-colors rounded-sm
        ${sizeStyle.button}
        ${active
          ? "bg-yellow-100 text-yellow-700"
          : "text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900"
        }
        disabled:opacity-50 disabled:cursor-not-allowed
        ${className}
      `}
      {...props}
    >
      <FormatIcon type={format} size={sizeStyle.icon} />
    </button>
  );
}

export { type FormatButtonProps };
